import React from 'react';
import classNames from 'classnames';
import { useState } from 'react';
import * as styles from './steps.module.sass';
import { StepsContainerProps } from './step_container.props.types';
import { Image } from '../../atoms/image';
import { useSelector } from 'react-redux';
import { viewportWidthSelector } from '../../../store/app/selector';
import { useConfig } from '../../../config/context';

export const StepsContainer = (props: StepsContainerProps) => {
  const [cerrntStep, setCurrentStep] = useState<number>(0);

  const tabLabels: React.ReactNode[] = [];
  const mobileTabLabels: React.ReactNode[] = [];
  const mobileView = useSelector(viewportWidthSelector);
  const config = useConfig();

  props.steps.forEach((item: { title: string; text: string }, key: number) => {
    {
      item.title &&
        mobileTabLabels.push(   
          <div className={styles.steps}>
            <p
              className={classNames(styles.mobile_steps_count, { [styles.active]: cerrntStep === key })}
              onClick={() => setCurrentStep(key)}
            >
              {item.title}
            </p>
            <p className={styles.mobile_steps_descriotion}>{item.text}</p>
          </div>,
        );
    }
  });

  const step = `step_wrapper_${[props.steps.length]}`;

  props.steps.forEach((item: { title: string; text: string }, key: number) => {
    {
      item.title &&
        tabLabels.push(
          <div className={styles[step]} onClick={() => setCurrentStep(key)} key={key}>
            {mobileView > config.MEDIAQUERY.MOBILE && (
              <div className={classNames(styles.step, { [styles.active]: cerrntStep === key })}>
                {item.title}
                <div className={classNames(styles.step_description, { [styles.active]: cerrntStep === key })}>
                  {mobileView > config.MEDIAQUERY.DESKTOP && item.text}
                </div>
              </div>
            )}
          </div>,
        );
    }
  });

  const { image } = props.steps[cerrntStep];

  
  const width = ((cerrntStep)/ (props.steps.length - 1/2)) * 100 + '%'

  return (
    <>
      {mobileView < config.MEDIAQUERY.MOBILE && (
        <div className={styles.mobile_container}>
          <div className={styles.progress_container}>
            <div className={styles.progress} style={{ width: width  }}></div>
            {mobileTabLabels}
          </div>
        </div>
      )}
      <div className={styles.wrapper}>
        {tabLabels}
        <div className={classNames(styles.img, styles.mocaps)}>
          <Image
            srcs={[
              {
                src: image.avif,
                type: 'image/avif',
              },
              {
                src: image.webp,
                type: 'image/webp',
              },
              {
                src: image.fallback?.url,
                type: 'image/png',
              },
            ]}
            src={image.webp}
            alt={image.alt}
          />
        </div>
        {mobileView > config.MEDIAQUERY.MOBILE && (
          <div className={classNames(styles.img, styles.circle_step)}>
            <Image srcs={props.srcs} src={props.src} alt={props.alt} />
          </div>
        )}

        <div className={styles.big_circle}></div>
      </div>

      {mobileView < config.MEDIAQUERY.DESKTOP && mobileView > config.MEDIAQUERY.MOBILE && (
        <div className={styles.text_description}>{props.steps[cerrntStep].text}</div>
      )}
    </>
  );
};
